// Others
import axiosClient from './axiosClient';
import { urlApiMasterData } from '~/utils/constants/apis';
import {
  IBodyCreateMasterData,
  IFormMasterData,
  IFormUpdateMasterData,
  IMasterData,
  IMasterDataDetail,
  IQueryMasterData,
} from '~/utils/interface/masterData';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IBodyUpdate } from '~/utils/interface/common';

const masterDataApi = {
  getListMasterData: (params: IQueryMasterData) => {
    const url = urlApiMasterData.getListMasterData;
    return axiosClient.get<IBaseResponse<IListDataResponse<IMasterData[]>>>(url, { params });
  },

  getDetailMasterData: (id: string) => {
    const url = urlApiMasterData.getDetailMasterData(id);
    return axiosClient.get<IBaseResponse<IMasterDataDetail>>(url);
  },

  createMasterData: (body: IBodyCreateMasterData) => {
    const url = urlApiMasterData.createMasterData;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  updateMasterData: (params: IBodyUpdate<IFormUpdateMasterData>) => {
    const { id, body } = params;
    const url = urlApiMasterData.updateMasterData(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteMasterData: (id: string) => {
    const url = urlApiMasterData.deleteMasterData(id);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default masterDataApi;
